import { connect, useDispatch } from 'react-redux';

import cls from './Company.module.scss';
import { setOnBoardingModalsVisibility } from '../../../reduxStore/actions/modalsActions';
import { Button } from '../../common';
import { APP_NAME, PROMO_VIDEO } from '../../../shared/utility';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import ReactPlayer from 'react-player';

const CompanyTutorials = props => {
    const { onBoardingModalsVisibility, onBoardingCompleted } = props;
    const dispatch = useDispatch();

    const {
        firstModalVisible,
        secondModalVisible,
        thirdModalVisible,
        fourthModalVisible,
        fifthModalVisible,
        sixthModalVisible,
        seventhModalVisible,
        eightModalVisible,
        ninthModalVisible,
        tenthModalVisible,
        eleventhModalVisible,
        twelvthModalVisible,
        lastModalVisible,
        templatesFirst,
        templatesSecond,
        templatesLastVisible
    } = onBoardingModalsVisibility;

    return onBoardingCompleted &&
        <>
            {firstModalVisible &&
                <TutorialBits style={{ top: '36%', right: '10%', width: '300px' }}
                    title={'Step 1: Your 1st Workflow - Create Customers Workflow'}
                    message={`Let us start by clicking New Workflow. If the menu disappears you can look for it at the Workflows menu above.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {secondModalVisible &&
                <TutorialBits style={{ top: '10%', right: '5%', width: '50%' }}
                    title={'Step 2: Create Your First Component'}
                    message={`But first, let's create a component. A component is a way for your users to input or view information. In forms these are fields that can hold a value and is the most important part of the workflow. Press Open to start creating one.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Use pre-built templates instead'} clicked={() => dispatch(setOnBoardingModalsVisibility({ templatesFirst: true }))} style={{ height: '30px' }} />
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}

            {thirdModalVisible &&
                <TutorialBits style={{ top: '5%', right: '5%', width: '300px' }}
                    title={'Step 3: Create Customer Listing Component'}
                    message={`Start by typing Customer Listing in the Name input box. After typing the name let's create several fields.\n In the Fields Selection, click the box, a drop down list should appear, look for and click Text in Input. Text should appear in Selected Fields. Click the settings icon and 
										change the Input name for Text to Customer Name then Save. Create another Text field, name it Customer ID. You may click the title of the video to enlarge.`}
                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtu.be/Cv9J5xdkMOU'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {fourthModalVisible &&
                <TutorialBits style={{ top: '10%', right: '5%', width: '50%' }}
                    title={'Step 4: Create Your Second Component'}
                    message={`In your workflow, while you can put all the input and output objects in one component, it will be better to group them. Specially if your workflow has several steps. Click Open again.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {fifthModalVisible &&
                <TutorialBits style={{ top: '5%', right: '5%', width: '300px' }}
                    title={'Step 5: Create the Customer Details Component'}
                    message={`Start by typing Customer Detail in the Name input box. After typing the name, create several fields.\n In the Fields Selection, look for and click Text in Input. Change the input name for Text to Customer Name then Save. Create two more Text fields, with the labels Address and Email. Select a fourth field, Date, name it Date Founded. Finally add a Customer ID field, click settings and add prefix ID of CUST-. Now click Save to finalize this component.`}

                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtu.be/7IWHYJFKHh4'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {sixthModalVisible &&
                <TutorialBits style={{ top: '20vh', left: '70%', width: '300px' }}
                    title={'Step 6: Create A Blank Workflow'}
                    message={`We can now proceed in creating your first workflow. Click Open in the Blank Workflow.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}

            {seventhModalVisible &&
                <TutorialBits style={{ top: '20vh', left: '60%', width: '500px' }}
                    title={'Step 7: Create Customer Master'}
                    message={`Name the workflow Customer Master, put a Description and press Save`}
                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtu.be/QHkQBYNLaCs'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {eightModalVisible &&
                <TutorialBits style={{ top: '0px', right: '0', width: '30%' }}
                    title={'Step 8: Create first Workflow Step '}
                    message={
                        "We will create our first step. This step will show your users a list of customers that have been previously created. For this we will need to add a list object that we will create out of the customer list component that you earlier created. Type a name for this step, i suggest something like 'Customer List' that will tell your users this step will list all orders. Add a description as well. \
				To add that list, we will go to the 'Components to be used' and you will need to click 'Attach Component' and select from the drop down Components [A-D] the Customer Listing component you created (You may see other predinfed components in the dropdown, so make sure to select the one you created by checking the fields included). Select it and click the check button. Then look for the 'Use as Transactions List' slider and set it to Yes. By doing this the step will create a Main List component that has columns based on the Customers List component. You may now Save "
                    }
                ><div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtu.be/oLeJ364930U'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>
                </TutorialBits>}

            {ninthModalVisible &&
                <TutorialBits style={{ top: '20%', right: '20%', width: '30%' }}
                    title={'Step 9: Create the last step'}
                    message={`The workflow is almost complete. We need a last step. Click the Builder Button above and double click New Step in the chart in the middle. You can also drag the New Step box into the chart. The new steps modal should appear`}
                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtu.be/9xREi3UE61E'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}

            {tenthModalVisible &&
                <TutorialBits style={{ top: '0px', right: '0', width: '30%' }}
                    title={'Step 10: Create last step '}
                    message={
                        "We will create our last step which we will name 'Customer Details'. You may describe this step as 'Input the customer details'. This will be step number 2, which means you need to connect it to a previous step. Click the Connect Step To drop down and select the previous step \
				you created which is 'Customer List'. Go to Components to be used, click Attach Component and select from the drop down Customer Detail from Components [A-D]. Set Is this the final step of this workflow slider to Yes. This is the last step. You may now Save."
                    }
                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtube.com/shorts/pAX6UYBX7rQ'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}

            {eleventhModalVisible &&
                <TutorialBits style={{ top: '10%', right: '0', width: '300px' }}
                    title={'Step 11: Connect a Workflow to a Module'}
                    message={`The workflow is now complete. It is complete when you have a start and end step. You can check each step by clicking the step. To connect the workflow to a module, click the Module button above.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}

            {twelvthModalVisible &&
                <TutorialBits style={{ top: '20%', right: '10%', width: '500px' }}
                    title={'Step 12: Create the Customers Module'}
                    message={`In the Select Module to Edit, select New Module. 
							In the Name of the Module, type Customers. For Output Title Name, look for Customer Name and Customer ID. Finally click Save. A module is where your users can view or save the information you linked with your workflows via the components.`}
                >
                    <div className={cls.video} style={{ flexDirection: 'column' }}>
                        <ReactPlayer width={'100%'} url={'https://youtube.com/shorts/qKP3yEenQkg'} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} style={{ height: '30px' }} />
                    </div>

                </TutorialBits>}
            {lastModalVisible &&
                <TutorialBits style={{ top: '15%', left: '10%', width: '300px' }}
                    title={'Congratulations!!!!'}
                    message={`If you see the module in the menu bar above, you have successfully linked components, the workflow and connected it to a module. You can now use your module to input data.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button title={'Close'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} />
                    </div>
                </TutorialBits>}

            {templatesFirst &&
                <TutorialBits style={{ top: '50%', right: '0%', width: '300px' }}
                    title={'Step 3: Pre-built Templates'}
                    message={`So instead of building your components, workflow and module from scratch, we will make use of FlowHero's pre-built template for Employee Master. Press the View Button`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} />
                    </div>
                </TutorialBits>}
            {templatesSecond &&
                <TutorialBits style={{ top: '25%', right: '0%', width: '300px' }}
                    title={'Step 4: Create using Templates'}
                    message={`We will create a Employee master workflow complete with the necessary Employee objects, a list and details. After creation of the workflow, a module is likewise created. Press Create. You can also scroll down and check the other templates as well if you wish a template other than customers. You can press its View button and then create.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                        <Button title={'Skip'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} />
                    </div>
                </TutorialBits>}
            {templatesLastVisible &&
                <TutorialBits style={{ top: '25%', right: '10%', width: '300px' }}
                    title={'Congratulations!!!!'}
                    message={`If you see the Employee Master workflow, you have successfully linked components, the workflow and connected it to a module. Close this page and you can see the new module in the upper left side of the next page. You can now use your module to input data.`}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button title={'Close'} clicked={() => dispatch(setOnBoardingModalsVisibility({}))} />
                    </div>
                </TutorialBits>}

        </>
}

export const TutorialBits = props => {
    const { title = APP_NAME, message = `Thank you for choosing ${APP_NAME} and hoping we will have a successful partnership `, children } = props;
    return <div style={{ position: 'fixed', top: '8px', right: '0', zIndex: '500', margin: '20px', minWidth: '400px', ...props?.style }}>
        <div className={cls.addStepTooltip} style={{ backgroundColor: ' var(--app-color-gray-lightest)', ddisplay: 'block' }}>
            <div className={cls.messageContainer}>
                <p className={cls.title}>
                    {title}
                </p>
                <p className={cls.message}>{message}</p>

                {children}
            </div>
        </div>

    </div>
}

const mapStateToProps = store => {
    const { authenticatedUser, } = store.authReducer;
    const { user } = store.sessionReducer;
    const { companyData, onBoardingCompleted } = store.flowReducer;
    const { onBoardingModalsVisibility } = store.modalsReducer;
    return {
        companyData,
        user,
        authenticatedUser,
        onBoardingModalsVisibility,
        onBoardingCompleted
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompanyTutorials);